export { ViewType1 as MagazinePageViewType1 } from 'components/Magazine/Page/Sections/Type1/ViewType1';
export { ManageType1 as MagazinePageManageType1 } from 'components/Magazine/Page/Sections/Type1/ManageType1';

export { ViewType2 as MagazinePageViewType2 } from 'components/Magazine/Page/Sections/Type2/ViewType2';
export { ManageType2 as MagazinePageManageType2 } from 'components/Magazine/Page/Sections/Type2/ManageType2';

export { ViewType3 as MagazinePageViewType3 } from 'components/Magazine/Page/Sections/Type3/ViewType3';
export { ManageType3 as MagazinePageManageType3 } from 'components/Magazine/Page/Sections/Type3/ManageType3';

export { ViewType4 as MagazinePageViewType4 } from 'components/Magazine/Page/Sections/Type4/ViewType4';
export { ManageType4 as MagazinePageManageType4 } from 'components/Magazine/Page/Sections/Type4/ManageType4';

export { ViewType5 as MagazinePageViewType5 } from 'components/Magazine/Page/Sections/Type5/ViewType5';
export { ManageType5 as MagazinePageManageType5 } from 'components/Magazine/Page/Sections/Type5/ManageType5';

export { ViewType6 as MagazinePageViewType6 } from 'components/Magazine/Page/Sections/Type6/ViewType6';
export { ManageType6 as MagazinePageManageType6 } from 'components/Magazine/Page/Sections/Type6/ManageType6';

export { ViewType7 as MagazinePageViewType7 } from 'components/Magazine/Page/Sections/Type7/ViewType7';
export { ManageType7 as MagazinePageManageType7 } from 'components/Magazine/Page/Sections/Type7/ManageType7';

export { ViewType8 as MagazinePageViewType8 } from 'components/Magazine/Page/Sections/Type8/ViewType8';
export { ManageType8 as MagazinePageManageType8 } from 'components/Magazine/Page/Sections/Type8/ManageType8';

export { ViewType9 as MagazinePageViewType9 } from 'components/Magazine/Page/Sections/Type9/ViewType9';
export { ManageType9 as MagazinePageManageType9 } from 'components/Magazine/Page/Sections/Type9/ManageType9';

export { ViewType10 as MagazinePageViewType10 } from 'components/Magazine/Page/Sections/Type10/ViewType10';
export { ManageType10 as MagazinePageManageType10 } from 'components/Magazine/Page/Sections/Type10/ManageType10';

export { ViewType11 as MagazinePageViewType11 } from 'components/Magazine/Page/Sections/Type11/ViewType11';
export { ManageType11 as MagazinePageManageType11 } from 'components/Magazine/Page/Sections/Type11/ManageType11';

export { ViewType12 as MagazinePageViewType12 } from 'components/Magazine/Page/Sections/Type12/ViewType12';
export { ManageType12 as MagazinePageManageType12 } from 'components/Magazine/Page/Sections/Type12/ManageType12';

export { ViewType13 as MagazinePageViewType13 } from 'components/Magazine/Page/Sections/Type13/ViewType13';
export { ManageType13 as MagazinePageManageType13 } from 'components/Magazine/Page/Sections/Type13/ManageType13';

export { ViewType14 as MagazinePageViewType14 } from 'components/Magazine/Page/Sections/Type14/ViewType14';
export { ManageType14 as MagazinePageManageType14 } from 'components/Magazine/Page/Sections/Type14/ManageType14';

export { ViewType15 as MagazinePageViewType15 } from 'components/Magazine/Page/Sections/Type15/ViewType15';
export { ManageType15 as MagazinePageManageType15 } from 'components/Magazine/Page/Sections/Type15/ManageType15';

export { MagazinePageSectionRenderer } from 'components/Magazine/Page/Sections/SectionRenderer';
export { MagazinePageSectionSelector } from 'components/Magazine/Page/Sections/SectionSelector';
